module.exports = __webpack_public_path__ + "static/prof-cho-1198d400fe8c61ac3e01d7332de025c5.png";